import React from "react";
import { useNavigate } from "react-router-dom";
import { Box, Divider, Typography } from "@mui/material";
import { CheckCircle } from "@phosphor-icons/react";
import { ContinueButton } from "../../components/Checkout/ContinueButton";
import { ContactoSeccion } from "./secciones/ContactoSeccion";
import { DatosPersonalesSeccion } from "./secciones/DatosPersonalesSeccion";
import { DomicilioSeccion } from "./secciones/DomicilioSeccion";
import { FormaPagoSeccion } from "./secciones/FormaPagoSeccion";
import { Confetti } from "./Confetti";
import { useActualizacionDatosForm } from "./useActualizacionDatosForm";

const columnStyle = {
    maxWidth: 760,
    mx: "auto",
    px: { xs: 2, md: 3 },
    py: { xs: 2, md: 4 },
} as const;

const ActualizacionDatosPage: React.FC = () => {
    const { methods, catalogos, estado, errorMensaje, selectedPaymentProviderCode, onSubmit } =
        useActualizacionDatosForm();

    const enviado = estado === "enviado";

    return (
        <>
            {enviado && <Confetti />}

            <Box sx={{ width: "100%", display: "flex", justifyContent: "center", mt: 2, mb: 1 }}>
                <Typography
                    sx={{
                        fontFamily: "inherit",
                        fontWeight: 700,
                        fontSize: "1.05rem",
                        color: "text.primary",
                    }}
                >
                    Actualización de datos
                </Typography>
            </Box>
            <Divider sx={{ mt: 1, borderColor: "grey.300" }} />

            <Box sx={columnStyle}>
                {enviado ? (
                    <ConfirmacionEnvio />
                ) : (
                    <>
                        <Typography
                            sx={{
                                mb: 3,
                                fontFamily: "inherit",
                                fontSize: "0.875rem",
                                color: "text.secondary",
                            }}
                        >
                            Actualizá tus datos personales, de facturación y de instalación. Te
                            vamos a contactar si necesitamos confirmar algo.
                        </Typography>

                        <ContactoSeccion methods={methods} />
                        <DatosPersonalesSeccion methods={methods} catalogos={catalogos} />
                        <DomicilioSeccion methods={methods} />
                        <FormaPagoSeccion
                            methods={methods}
                            catalogos={catalogos}
                            selectedPaymentProviderCode={selectedPaymentProviderCode}
                        />

                        {errorMensaje && (
                            <Typography color="error" fontSize={13} sx={{ mb: 2 }}>
                                {errorMensaje}
                            </Typography>
                        )}

                        <ContinueButton onClick={onSubmit} isLoading={estado === "enviando"}>
                            Enviar actualización
                        </ContinueButton>
                    </>
                )}
            </Box>
        </>
    );
};

const ConfirmacionEnvio: React.FC = () => {
    const navigate = useNavigate();

    return (
        <Box sx={{ textAlign: "center", py: 6 }}>
            <CheckCircle size={56} weight="fill" color="#1a1c1e" />
            <Typography sx={{ mt: 2, fontFamily: "inherit", fontWeight: 700, fontSize: "1.1rem" }}>
                ¡Listo! Recibimos tu actualización de datos.
            </Typography>
            <Typography
                sx={{ mt: 1, fontFamily: "inherit", fontSize: "0.875rem", color: "text.secondary" }}
            >
                Nuestro equipo la va a revisar a la brevedad.
            </Typography>

            <Box sx={{ mt: 4 }}>
                <ContinueButton onClick={() => navigate("/")}>Volver a la tienda</ContinueButton>
            </Box>
        </Box>
    );
};

export default ActualizacionDatosPage;
